export default class Analytics {
  constructor(data) {
    this.googlAnalytics4Id = data.google_analytics4_id;
  }
}
